import axios from '@src/public/utils/request';

// 加入追踪
export const followTimeline = id => {
    return axios.post('/timeline/front/api/follows', {
        timelineId: id,
    });
};

// 取消追踪
export const cancelFollowTimeline = id => {
    return axios.delete('/timeline/front/api/follows', {
        data: { timelineId: id },
    });
};

// 评论弹幕接口
export const getCommonList = ({ id, size }) => {
    // mock
    // return axios.get(`https://api.ifengcloud.ifeng.com/mock/1749/timeline/front/api/timelines/${id}/bullet-comments`, {
    //     params: { size },
    // });

    return axios.get(`/timeline/front/api/timelines/${id}/bullet-comments`, {
        params: { size },
    });
};

// 获取节点定位接口
export const getNodePosition = nodeId => {
    return axios.get(`/timeline/front/api/nodes/${nodeId}/position`);
};
